module.exports = __webpack_public_path__ + "static/media/sidemenu_logo.27c9af9b.jpg";